import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../component/Elements/Session";
import { paths } from "../../config/constants";
const SESSION_TIMEOUT = 30 * 60 * 1000;

const useSessionTimeout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Check inactivity when app starts/reopens
  useEffect(() => {
    const lastActivity = Number(localStorage.getItem("lastActivity"));

    if (
      lastActivity &&
      Date.now() - lastActivity >= SESSION_TIMEOUT
    ) {
      logoutUser({
        dispatch,
        navigate,
        expired: true,
        showToast: false,
      });

      return;
    }

    // Start a new activity window
    localStorage.setItem("lastActivity", Date.now().toString());
  }, [dispatch, navigate]);

  // Track activity while app is open
  useEffect(() => {
    let timeout;

    const updateActivity = () => {
      localStorage.setItem("lastActivity", Date.now().toString());

      clearTimeout(timeout);

      timeout = setTimeout(async () => {
        await logoutUser({
          dispatch,
          navigate,
          expired: true,
          showToast: false,
        });
      }, SESSION_TIMEOUT);
    };

    const events = [
      "click",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) =>
      window.addEventListener(event, updateActivity)
    );

    updateActivity();

    return () => {
      clearTimeout(timeout);

      events.forEach((event) =>
        window.removeEventListener(event, updateActivity)
      );
    };
  }, [dispatch, navigate]);

  // Multi-tab logout sync
  useEffect(() => {
    const syncLogout = (event) => {
      if (event.key === "logout") {
        navigate(paths.accounts.login, {
          replace: true,
        });
      }
    };

    window.addEventListener("storage", syncLogout);

    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, [navigate]);
};

export default useSessionTimeout;